module.exports = __webpack_public_path__ + "img/trash.f1ca3474.svg";